export default __webpack_public_path__ + "static/media/mastercard-old.13fbb417.svg";